import { memo, useMemo } from 'react';

import clsx from 'clsx';
import dayjs from 'dayjs';
import { Book, BookAlert, BookCheck, BookMinus, Clock, Users } from 'lucide-react';

import css from './UserGuideStatisticCard.module.css';

import { UserGuideStatistic } from 'v2/types/UserGuideModel';
import { formatNumber } from 'v2/utils';

interface UserGuideStatisticsTableProps {
  statistic: UserGuideStatistic;
}

export const UserGuideStatisticCard = memo<UserGuideStatisticsTableProps>(({ statistic }) => {
  const duration = useMemo(() => {
    return dayjs.duration(statistic.averageCompletionTime);
  }, [statistic]);

  return (
    <div className={css.userGuideStatisticCard}>
      <div className={css.userGuideStatisticCardTitleContainer}>
        <p className={css.userGuideStatisticCardTitle}>{statistic.guideKey}</p>

        <p className={css.userGuideStatisticCardMetric}>
          <Users width={16} />
          Total Users:
          <span className={css.userGuideStatisticCardMetricValue}>{formatNumber(statistic.total)}</span>
        </p>
      </div>

      <div className={css.userGuideStatisticCardMetrics}>
        <p className={clsx(css.userGuideStatisticCardMetric, css.completed)}>
          <BookCheck width={17} />
          Completed:
          <span className={css.userGuideStatisticCardMetricValue}>{formatNumber(statistic.completed)}</span>
        </p>

        <p className={clsx(css.userGuideStatisticCardMetric, css.inProgress)}>
          <Book width={16} />
          In Progress:
          <span className={css.userGuideStatisticCardMetricValue}>{formatNumber(statistic.inProgress)}</span>
        </p>

        <p className={clsx(css.userGuideStatisticCardMetric, css.skipped)}>
          <BookMinus width={16} />
          Skipped:
          <span className={css.userGuideStatisticCardMetricValue}>{formatNumber(statistic.skipped)}</span>
        </p>

        <p className={css.userGuideStatisticCardMetric}>
          <BookAlert width={16} />
          Not Started:
          <span className={css.userGuideStatisticCardMetricValue}>{formatNumber(statistic.notStarted)}</span>
        </p>
      </div>

      <p className={css.userGuideStatisticCardMetric}>
        <Clock width={14} />
        {Math.floor(duration.minutes())} m {duration.seconds()} s avg
      </p>
    </div>
  );
});

UserGuideStatisticCard.displayName = 'UserGuideStatisticCard';
